<template>
  <div class="contact-remove">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="$t('contact.removeContact')"
      :left-text="$t('base.cancel')"
      @click-left="handleClickLeft"
      @click-right="handleClickRight"
    >
      <span :class="[removeIds.length === 0 && 'disabled']" slot="right">{{removeIds.length ? $t('base.deleteCount', [removeIds.length]) : $t('base.delete') }}</span>
    </van-nav-bar>
    <!-- <div class="search-contact" @click="onSearchInputClick">
      <van-field
        :value="$t('contact.search.contact')"
        left-icon="search"
        disabled
      />
    </div> -->
    <div class="select-list">
      <div
        class="select-item"
        v-for="(item, index) in items"
        :key="`${item.item_typed_id}-${index}`"
        @click="handleCheck(index, item.item_typed_id)"
      >
        <van-checkbox
          v-model="item.delete"
          shape="round"
          ref="checkbox"
          @click.stop="handleCheck(index, item.item_typed_id)"
        />
        <avatar
          v-if="item.is_department || item.is_group"
          class="thumb-icon"
          :type="item.is_department ? 'department' : 'group'"
          :size="36"
        />
        <avatar
          v-else
          class="thumb-icon"
          :user="item"
          :isActive="item.is_active"
          :size="36"
        />
        <div class="item-main has-border-bottom">
          <div class="item-name ellipsis">
            {{item.name}}
            <span class="primary-color" v-if="item.current_user">({{$t('contact.includingMe')}})</span>
          </div>
          <div class="item-meta ellipsis">{{item.login || $t('base.person', [item.user_count])}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '../utils/Icon'
import Avatar from '../utils/Avatar'
import {i18n} from '@/utils/i18n'
import {confirm} from '@/utils/common'

export default {
  name: 'ContactRemove',
  i18n,
  components: {
    Icon,
    Avatar
  },
  props: {
    selectListProp: Array,
    selectEntitiesProp: Object
  },
  data () {
    return {
      items: [],
      removeIds: []
    }
  },
  created () {
    this.items = this.selectListProp.map(id => ({...this.selectEntitiesProp[id], delete: false}))
  },
  methods: {
    handleClickLeft () {
      this.$emit('close-popup')
    },
    handleClickRight () {
      confirm({
        className: 'dialog danger-dialog',
        message: i18n.t('contact.removeConfirm'),
        confirmButtonText: i18n.t('base.delete'),
        cancelButtonText: i18n.t('base.cancelText')
      }).then(() => {
        this.$emit('remove-contacts', this.removeIds)
        this.$emit('close-popup')
      })
    },
    onSearchInputClick () {
    },
    handleCheck (index, item_typed_id) {
      this.$refs.checkbox[index].toggle()
      const position = this.removeIds.indexOf(item_typed_id)
      if (position >= 0) {
        this.removeIds = [...this.removeIds.slice(0, position), ...this.removeIds.slice(position + 1)]
      } else {
        this.removeIds.push(item_typed_id)
      }
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.contact-remove {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

</style>
